import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminScannersScannerRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ a11y_scanner_id }) {
    const { content } = await this.store.request(
      findRecord('a11y-scanner', a11y_scanner_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
